import { frases } from './constants';
import logoPng from '../../assets/logo_uni.png';

/**
 * @typedef {Object} Action
 * @property {'LOAD_PEDIDOS' | 'ADD_PEDIDO'| 'UPDATE_PEDIDO'| 'DELETE_PEDIDO'| 'RESET'} type
 * @property {*} payload
 */

/**
 * @param {*} state
 * @param {Action} action
 */
export function ordersReducer(state, action) {
  switch (action.type) {
    case 'LOAD_PEDIDOS':
      return action.payload;
    case 'ADD_PEDIDO':
      return addOrderAction(state, action.payload);
    case 'UPDATE_PEDIDO':
      return updateOderAction(state, action.payload);
    case 'DELETE_PEDIDO':
      return deleteOrderAction(state, action.payload);
    case 'RESET':
      return [];
    default:
      return state;
  }
}

function addOrderAction(state, payload) {
  const newState = [...state];
  const order = payload;
  const orderIndex = newState.findIndex((p) => p.Id === order.Id);

  if (orderIndex !== -1) {
    newState[orderIndex] = order;
  } else {
    newState.unshift(order);
  }

  return newState;
}

function updateOderAction(state, order) {
  const newState = [...state];
  const pedidoIndex = newState.findIndex((p) => p.Id === order.Id);

  if (pedidoIndex !== -1) {
    newState[pedidoIndex] = order;
  } else {
    newState.unshift(order);
  }

  return newState;
}

function deleteOrderAction(state, orderId) {
  const newState = [...state];
  const orderIndex = state.findIndex((t) => t.Id === orderId);

  if (orderIndex !== -1) {
    newState.splice(orderIndex, 1);
  }

  return newState;
}

function fraseAleatoria() {
  const indice = Math.floor(Math.random() * frases.length);
  return frases[indice];
}

export function enviarNotificacao(data) {
  if (!('Notification' in window)) {
    console.info('Este navegador não suporta notificações.');
    return;
  }

  if (Notification.permission !== 'granted') {
    console.info('Você precisa conceder permissão para enviar notificações.');
    return;
  }

  const options = {
    body: `${
      data?.NomeSemCadastro ? data?.NomeSemCadastro : 'Um cliente'
    } acabou de fazer um pedido e aguarda sua aprovação.`,
    icon: logoPng,
  };

  const notification = new Notification(fraseAleatoria(), options);
  notification.onclick = function () {
    window.location.href = '/g_pedidos';
    notification.close();
  };
}

export function imprimirPedido(pedido) {
  window.open(
    '/g_imprimir_pedido/' + pedido.Id,
    'minhaJanela',
    'height=800,width=800',
  );
}

function getStatus(order) {
  if (order.Status !== 'PENDENTE') {
    return order.Status;
  }

  if ({ AG: true, AGRE: true }[order.TipoEntrega]) {
    return 'AGENDAMENTO';
  }

  return order.Status;
}

function getorderDate(data) {
  const orderDate = new Date(data.DataPedido);

  const [hour, min, sec] = data?.Hora?.split(':');
  orderDate.setHours(hour);
  orderDate.setMinutes(min);
  orderDate.setSeconds(sec);

  return orderDate;
}

export function getDataByStatus(data) {
  const totalByStatus = {};
  const ordersByStatus = {};

  data.forEach((order) => {
    const status = getStatus(order);

    if (totalByStatus[status]) {
      totalByStatus[status] += Number(order.ValorTotal) || 0;
    } else {
      totalByStatus[status] = Number(order.ValorTotal) || 0;
    }

    if (ordersByStatus[status]) {
      ordersByStatus[status].push(order);
    } else {
      ordersByStatus[status] = [order];
    }
  });

  for (const status in ordersByStatus) {
    const isSchedule = status === 'AGENDAMENTO';

    ordersByStatus[status].sort((a, b) => {
      const dateA = isSchedule ? new Date(a.DataAgendamento) : getorderDate(a);
      const dateB = isSchedule ? new Date(b.DataAgendamento) : getorderDate(b);

      const res = dateA.getTime() - dateB.getTime();

      if (res === 0) return 0;

      return res > 0 ? 1 : -1;
    });
  }

  return { totalByStatus, ordersByStatus };
}
